<template>
  <div>
    <loginbox></loginbox>
    <detailbox :title="'活动详情'" :info="info.recover_info"></detailbox>
    <infolist :title="'系统回收'" :type="3" :qq="info.qq_recover" :qqShow="info.display_qq_recover" :wechat="info.service_recover" :wechatShow="info.display_weixin_recover" :isRetrieve="1"></infolist>
    <detailbox :title="'活动细则'" :info="info.recover_rule"></detailbox>
    <div class="bar"></div>
  </div>
</template>

<script>
  import loginbox from '@/components/common/loginbox/loginbox'
  import detailbox from '@/components/common/detailbox/detailbox'
  import infolist from '@/components/common/infolist/infolist'
  import { configResource } from '@/resource/resource'
  import {mapState, mapMutations} from 'vuex'
  const ERR_OK = 0
  export default {
    name: 'recoverpage',
    data () {
      return {
        info: ''
      }
    },
    computed: {
      ...mapState(['config_info'])
    },
    created () {
      this.scroll()
      if (!this.config_info.reInfo) {
        this.getConfig()
      } else {
        this.info = this.config_info.reInfo
      }
    },
    mounted () {
    },
    methods: {
      scroll () {
        setTimeout(() => {
          this.$emit('bscroll')
        }, 20)
      },
      getConfig () {
        configResource.config({ config: 'recover_info,recover_rule,qq_recover,display_qq_recover,display_weixin_recover,service_recover' }).then(response => {
          response = response.body
            if (response.errcode === ERR_OK) {
              this.config_info.reInfo = response.data
              this.info = response.data
            }
        })
      },
        // 更新vuex状态信息
      ...mapMutations([
        'CONFIG_INFO'
      ])
    },
    components: {
      loginbox,
      detailbox,
      infolist
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .bar
    height 0.2rem
    width 100%
</style>



// WEBPACK FOOTER //
// src/components/recoverpage/recoverpage.vue